var _circle, _circle2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRadioCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10.2993,
    r: 8,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10.2993,
    r: 8.25,
    stroke: "#28C76F",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4168 10.2993V9.7743C16.4168 9.4243 16.1835 9.19096 15.8335 9.19096C15.4835 9.19096 15.2502 9.4243 15.2502 9.7743V10.2993C15.2502 13.216 12.9168 15.5493 10.0002 15.5493C7.0835 15.5493 4.75016 13.216 4.75016 10.2993C4.75016 7.38263 7.0835 5.0493 10.0002 5.0493C10.7585 5.0493 11.4585 5.2243 12.1585 5.51596C12.4502 5.63263 12.8002 5.51596 12.9168 5.2243C13.0335 4.93263 12.9168 4.58263 12.6252 4.46596C11.8085 4.05763 10.8752 3.88263 10.0002 3.88263C6.44183 3.88263 3.5835 6.74096 3.5835 10.2993C3.5835 13.8576 6.44183 16.716 10.0002 16.716C13.5585 16.716 16.4168 13.8576 16.4168 10.2993ZM16.0085 4.64096C16.2418 4.40763 16.5918 4.40763 16.8252 4.64096C17.0585 4.8743 17.0585 5.2243 16.8252 5.45763L10.4085 11.8743C10.2918 11.991 10.1168 12.0493 10.0002 12.0493C9.88349 12.0493 9.70849 11.991 9.59182 11.8743L7.84183 10.1243C7.60849 9.89096 7.60849 9.54096 7.84183 9.30763C8.07516 9.0743 8.42516 9.0743 8.65849 9.30763L10.0002 10.6493L16.0085 4.64096Z",
    fill: "#28C76F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioCheck);
export default __webpack_public_path__ + "static/media/radioCheck.59364be2a8bc1f46f120e2ae331b4c02.svg";
export { ForwardRef as ReactComponent };